import {
  SAST_FINDINGS_PAGE,
  SCA_FINDINGS_PAGE,
  SECRETS_FINDINGS_PAGE,
} from "@shared/constants";

import { fullstory } from "../fullstoryUtils";

const ALLOWED_LOGGING_PAGES = [
  SAST_FINDINGS_PAGE,
  SCA_FINDINGS_PAGE,
  SECRETS_FINDINGS_PAGE,
];

/**
 *
 * @param paramsName Name of the filter i.e. url params for filtering
 * @param fromPage Page from which the filter is being applied
 * @description Logs the filter being applied to Fullstory for tracking purposes
 */
export const onChangeFilterWithLogging = (
  paramsName: string,
  fromPage: string
) => {
  if (ALLOWED_LOGGING_PAGES.includes(fromPage)) {
    fullstory.event(`Filtered by ${paramsName}`, {
      Page: fromPage,
    });
  }
};
